
import { Options, Vue } from 'vue-class-component';
import store from '@/store';

@Options({})
export default class ProviderLayout extends Vue {
    get currentProfileId(): string { return (store.state.loggedUser as any).currentProfileIdentifier || ''; }
    get canOpenProfile(): boolean { return !!this.currentProfileId && (store.state.loggedUser as any).currentProfileStatus >= 1; }
    get selectedLabel(): string {
        const user = store.state.loggedUser as any;
        return [user.currentProviderName, user.currentSupplierCode, user.currentCompany?.text].filter(Boolean).join(' · ');
    }

    get scrollable() {
        return this.$route.meta.scrollable ? "scrollable" : "";
    }
}
